//

// TODO: This could be read from feature-flag or QCS
const numAllowedSharesPerDataset = 1;

const useShareCounts = (sharesForDataset) => {
  if (!sharesForDataset) {
    return [0, numAllowedSharesPerDataset];
  }
  return [sharesForDataset.length, numAllowedSharesPerDataset];
};

export default useShareCounts;
